import SimpleField from './simple';

export default SimpleField;
